import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Add as AddIcon, LocalShipping } from "@material-ui/icons";
import CardTable from "components/CardTable/CardTable";
import { ModalV2 } from "components/Modal/ModalV2";
import RegularButton from "components/CustomButtons/Button";
import Snackbar from "components/Snackbar/Snackbar";
import { useSearch } from "hooks/useSearch";
import { useOpenComponent } from "hooks/useOpenComponent";
import { columns } from "./columns";
import { AddShipperTruck } from "./AddShipperTruck";
import { handleCloseFunction, handleOpenAddFunction, setMapDataFunction } from "./utilsShipperTrucksPage";
import {
  getShipperTruck,
  resetShipperTruckSelected,
  addShipperTruckMode
} from "redux/actions/shipperTrucks/shipperTrucksAction";

export const ShipperTrucksPage = () => {
  const dispatch = useDispatch();
  const { clearSnackbar } = useSearch();
  const { shipperTrucks, loading } = useSelector(state => state.PG);
  const { color, message, isOpen: isOpenSnack } = useSelector(({ search }) => search);
  const [mapData, setMapData] = useState([]);
  const { isOpen, handleIsOpen } = useOpenComponent();

  const handleClose = () => handleCloseFunction(dispatch, resetShipperTruckSelected, handleIsOpen);
  const handleOpenAdd = () => handleOpenAddFunction(dispatch, addShipperTruckMode, handleIsOpen);

  useEffect(() => {
    dispatch(getShipperTruck());
  }, [dispatch]);

  useEffect(() => {
    setMapDataFunction(setMapData, shipperTrucks, handleIsOpen);
  }, [shipperTrucks]);

  return (
    <>
      <CardTable
        hasHeader
        icon={<LocalShipping />}
        title={"PG"}
        columns={columns}
        data={mapData}
        loading={loading}
        blockBtn
        hasControl
        controls={
          <>
            <RegularButton round justIcon tooltip="Agregar nuevo PG" color="info" style={{ marginTop: 10 }} onClick={handleOpenAdd}>
              <AddIcon style={{ margin: 0 }} />
            </RegularButton>
          </>
        }
      />
      <ModalV2
        toRight
        open={isOpen}
        onClose={handleClose}
      >
        <AddShipperTruck handleClose={handleClose} />
      </ModalV2>
      <Snackbar
        place="tr"
        color={color}
        message={message}
        open={isOpenSnack}
        closeNotification={clearSnackbar}
        close
      />
    </>
  );
};
